import React, { useState, useRef, useEffect } from "react";
import * as styles from "./Otpinput.module.css";

const OTPInput = ({ OTPlength = 6, onOTPComplete }) => {
  const [otpValues, setOtpValues] = useState(Array(OTPlength).fill(""));
  const inputs = useRef([]);

  // useEffect(() => {
  //   if (inputs.current[0]) {
  //     inputs.current[0].focus();
  //   }
  // }, []);

  useEffect(() => {
    if (otpValues.includes("")) {
      onOTPComplete(false);
    } else {
      onOTPComplete(otpValues.join(""));
    }
  }, [otpValues]);

  const handleChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "");

    if (!value) return;

    const newOtp = [...otpValues];
    newOtp[index] = value;
    setOtpValues(newOtp);

    if (index < OTPlength - 1) {
      inputs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();

      const newOtp = [...otpValues];

      if (newOtp[index]) {
        newOtp[index] = "";
        setOtpValues(newOtp);
      } else if (index > 0) {
        newOtp[index - 1] = "";
        setOtpValues(newOtp);
        inputs.current[index - 1].focus();
      }
    }
  };
  const handlePaste = (e) => {
    e.preventDefault();

    const pasteData = e.clipboardData.getData("text").replace(/\D/g, ""); // Remove non-digits
    if (!pasteData) return;

    const newOtp = [...otpValues];
    for (let i = 0; i < OTPlength; i++) {
      if (i < pasteData.length) {
        newOtp[i] = pasteData[i];
      }
    }

    setOtpValues(newOtp);

    const nextIndex = Math.min(pasteData.length, OTPlength - 1);
    inputs.current[nextIndex].focus();
  };

  return (
    <>
      <div className={styles.containerStyle}>
        {otpValues.map((digit, index) => (
          <input
            key={index}
            type="text"
            maxLength="1"
            autoFocus={index === 0 ? true : false}
            value={digit}
            ref={(el) => (inputs.current[index] = el)}
            onChange={(e) => handleChange(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            className={styles.inputStyle}
            onPaste={handlePaste}
          />
        ))}
      </div>
    </>
  );
};

export default OTPInput;
